import React from 'react';
import { Box, useTheme } from '@mui/material';
import MenuItemsDashboardPage from '../components/dashboardComponents/Menu/MenuItemsDashboardPage.js';
import DashboardNavbar from '../components/dashboardComponents/utils/DashboardNavbar.js';

/**
 * The base page the dashboard menu editing dashboard.
 */
const ManagerMenuDashboard = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        bgcolor: theme.palette.background.default,
        color: theme.palette.text.primary,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <DashboardNavbar />
      <Box flexGrow={1}>
        <MenuItemsDashboardPage />
      </Box>
    </Box>
  );
};

export default ManagerMenuDashboard;
